import { randomUUID } from 'uncrypto'
import { useDayjs, useCookie, createSharedComposable } from '#imports'

const _useVisitorIdCookie = () => {
    const dayjs = useDayjs()
    const visitorIdCookie = useCookie('_ctvisitor', {
        sameSite: 'lax',
        maxAge: dayjs.duration({ years: 1 }).asSeconds(),
        path: '/',
        secure: true,
        httpOnly: false,
    })

    function setVisitorIdCookie() {
        if (visitorIdCookie.value) return

        visitorIdCookie.value = randomUUID()
    }

    return {
        visitorIdCookie,
        setVisitorIdCookie,
    }
}

/**
 * Shared on the client so all call sites reuse one cookie ref — every
 * `useCookie` ref opens a BroadcastChannel and posts a message on
 * instantiation (Nuxt >= 3.18), which is O(N²) in refs on tile-heavy pages.
 * Kept per-call on the server, where a shared instance would leak state
 * between requests.
 */
export const useVisitorIdCookie = import.meta.client ? createSharedComposable(_useVisitorIdCookie) : _useVisitorIdCookie
